import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path fill="#C51918" stroke="#FFD018" d="M16.5 2.5v7h-17v-7h17Z" />
      <Path
        fill="#FFD018"
        d="M3.575 4.665c-.06 0-.109-.135-.109-.303 0-.167.049-.302.109-.302h8.705c.06 0 .109.135.109.302 0 .168-.049.303-.109.303H3.575Z"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m12.048 4.3.505-.644.895.645-.895.662-.505-.662Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FFD018"
        d="M3.575 6.665c-.06 0-.109-.135-.109-.303 0-.167.049-.302.109-.302h8.705c.06 0 .109.135.109.302 0 .168-.049.303-.109.303H3.575Z"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m12.048 6.3.505-.644.895.645-.895.662-.505-.662Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FFD018"
        d="M2.173 7.91c-.08 0-.146-.154-.146-.343 0-.19.065-.344.146-.344h11.672c.08 0 .145.154.145.344 0 .19-.065.343-.145.343H2.173Z"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M4.409 6.026s1.42-2.99 3.452-2.99 3.5 2.99 3.5 2.99-1.792 2.95-3.476 2.95c-1.683 0-3.476-2.95-3.476-2.95Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={8}
        height={6}
        x={4}
        y={3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M4.409 6.026s1.42-2.99 3.452-2.99 3.5 2.99 3.5 2.99-1.792 2.95-3.476 2.95c-1.683 0-3.476-2.95-3.476-2.95Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#272727"
          fillRule="evenodd"
          d="M7.962 2.84s-.463.563-.309 1.1c.155.537.515.48.515.953s-.167.955 0 .955c.166 0 .224.327.072.548-.152.221-.287.228-.278.588.01.36.796.713.415.713-.381 0-.884.37-.724.37.16 0 .996.289.996.667v.681H4.286V2.84h3.676Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M5.91 7.116h-.218V6.23h.217v.885Zm.32 0h-.217V6.23h.216v.885Zm.32 0h-.217V6.23h.218v.885Zm.321 0h-.218V6.23h.218v.885Zm.32 0h-.217V6.23h.217v.885Zm.32 0h-.217V6.23h.218v.885ZM5.91 5.846h-.217v-.885h.217v.885Zm.32 0h-.216v-.885h.216v.885Zm.322 0h-.218v-.885h.218v.885Zm.32 0h-.218v-.885h.218v.885Zm.32 0h-.217v-.885h.217v.885Zm.32 0h-.217v-.885h.218v.885Z"
        />
        <Path
          fill="#272727"
          d="M8.488 7.116h-.217V6.23h.217v.885Zm.32 0h-.216V6.23h.217v.885Zm.322 0h-.218V6.23h.218v.885Zm.32 0h-.218V6.23h.218v.885Zm.32 0h-.217V6.23h.218v.885Zm.32 0h-.217V6.23h.218v.885Zm-1.602-1.27h-.217v-.885h.217v.885Zm.32 0h-.216v-.885h.217v.885Zm.322 0h-.218v-.885h.218v.885Zm.32 0h-.218v-.885h.218v.885Zm.32 0h-.217v-.885h.218v.885Zm.32 0h-.217v-.885h.218v.885Z"
        />
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M6.616 3.536c-.304.094-.444.892-.41 1.085.034.193.138-.024.138-.024s.21.457.232.58c.022.123.132-.186.132-.186s.366.252.415.532c.05.28.124-.32.124-.32l.082-.015-.052-.297.158.135-.049-.276s.119.155.089-.016l-.047-.266-.041-.234.156-.027s-.623-.766-.927-.671Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M13.044 6.847c-.316.04-.591.802-.591.998 0 .196.139 0 .139 0s.128.487.128.612.163-.16.163-.16.316.311.316.596c0 .284.177-.295.177-.295h.084v-.301l.132.16v-.28s.09.173.09 0v-.508h.159s-.48-.862-.797-.822ZM2.796 6.732c.316.04.592.802.592.998 0 .196-.14 0-.14 0s-.127.487-.127.612-.163-.16-.163-.16-.316.31-.316.595-.178-.294-.178-.294H2.38v-.301l-.131.16v-.28s-.09.173-.09 0v-.508H2s.48-.862.796-.822Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
